import { routes } from '@spa/core/router/appRoutesConfig'
import { CustomerCareMenu } from '@spa/features/externals/intercom'
import {
  AuthenticationRefreshGuard,
  useAuthState
} from '@spa/scenes/Auth/shared/services'
import { useNewFlowAssignmentRollout } from '@spa/scenes/Auth/shared/services/rollout/useClientRollout'
import { AccountCreationRoutes } from '@spa/scenes/Onboarding/flows/AccountCreation'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { AuthenticatedApp } from './AuthenticatedApp/AuthenticatedApp'
import { GuestApp } from './GuestApp/GuestApp'
import { UnauthenticatedApp } from './legacy/UnauthenticatedApp/UnauthenticatedApp'

const AuthenticatedLayout = ({ children }: { children: ReactNode }) => (
  <AuthenticationRefreshGuard>
    <CustomerCareMenu />
    {children}
  </AuthenticationRefreshGuard>
)

const isInAccountCreationFlow = (pathname: string): boolean => {
  const allowedPaths = [
    routes.accountCreationUserInfo.path,
    routes.accountCreationCompanyInfo.path
  ]
  return allowedPaths.includes(pathname)
}

export const AppEntryController = () => {
  const { isAuthenticated, auth } = useAuthState()
  const location = useLocation()
  const newFlow = useNewFlowAssignmentRollout()

  const isAccountCreation = Boolean(auth?.isAccountCreationInProgress)

  if (newFlow.isEnabled) {
    if (!isAuthenticated) {
      return <GuestApp />
    }

    if (isAccountCreation) {
      if (!isInAccountCreationFlow(location.pathname)) {
        return <Navigate to={routes.accountCreationUserInfo.path} replace />
      }

      return (
        <AuthenticatedLayout>
          <AccountCreationRoutes />
        </AuthenticatedLayout>
      )
    }
  }

  if (isAuthenticated) {
    return (
      <AuthenticatedLayout>
        <AuthenticatedApp />
      </AuthenticatedLayout>
    )
  }

  // Legacy unauthenticated
  return (
    <>
      <UnauthenticatedApp />
      <CustomerCareMenu />
    </>
  )
}
